type Props = {
  className?: string;
};

const CallIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.809 18.8731C17.9731 18.8731 18.92 17.9261 18.92 16.7621V13.9474C18.92 13.6444 18.7262 13.3757 18.439 13.2802L14.2269 11.8728C14.0207 11.8035 13.7953 11.835 13.6139 11.9546L12.2956 12.8333C12.0026 13.0286 11.6265 13.0594 11.3217 12.883C9.71459 11.9532 7.96682 10.2054 7.03696 8.59827C6.86061 8.29347 6.89136 7.91732 7.08666 7.6243L7.96534 6.30601C8.08558 6.12526 8.11584 5.8992 8.04711 5.69307L6.63978 1.48098C6.54432 1.19379 6.27561 1 5.97257 1H3.11099C1.94695 1 1 1.93705 1 3.1011C1 11.2083 8.70175 18.8731 16.809 18.8731"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default CallIcon;
